<template>
  <component 
    :is="baseElement"
    v-if="isSanitized"
    v-html="sanitizedHtml" />
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "SanitizeHtml",
  props: {
    dirty: {
      type: [String, Object],
      default: undefined,
    },
    baseElement: {
      type: String,
      default: "div",
    },
    dirtyFallback: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sanitizedHtml () {
      let result = "";

      if ( this.dirty ) {
        try {
          result = DOMPurify.sanitize( this.dirty );
        } catch ( _ex ) {
          this.logWarning();
        }
      }

      return result;
    },
    isSanitized () {
      return !!this.sanitizedHtml;
    },
  },
  methods: {
    logWarning ( warning = "Security Vulnerability: Injected HTML has not been sanitized" ) {
      console.warn( warning );
    },
  },
};
</script>
